import { createFileRoute, redirect } from "@tanstack/react-router";

// Redirect slug cũ /tu-vi-detail → /tu-vi-chi-tiet (giữ backlink/SEO).
export const Route = createFileRoute("/tu-vi-detail")({
  beforeLoad: () => {
    throw redirect({ to: "/tu-vi-chi-tiet", replace: true });
  },
  component: () => null,
});
